import {
  SPACE_PARTICIPANTS,
  SPACE_PARTICIPANTS_HISTORY,
} from '../../constants/endpoints';
import request from '../request';

export const getParticipants = async ({ spaceId, skip, sort, limit, role }) => {
  const {
    data: { participants },
  } = await request({
    method: 'get',
    url: SPACE_PARTICIPANTS({
      spaceId,
      skip,
      sort,
      limit,
      role,
    }),
  });

  return participants;
};

export const getParticipantsHistory = async (spaceId, before, limit) => {
  const { data: participantsHistory } = await request({
    method: 'get',
    url: SPACE_PARTICIPANTS_HISTORY({ spaceId, before, limit }),
  });

  return participantsHistory;
};
